class QueryCursor {
	constructor(client, queryId) {
		this.queryId = queryId;
		this.client = client;
	}

	getResult(offset, limit) {
		return this.client.getResult(this.queryId, offset, limit);
	}

	close() {
		return this.client.removeQuery(this.queryId);
	}
}

export default QueryCursor;


// WEBPACK FOOTER //
// ./resources/WEB-INF/src/core/QueryCursor.js